import { render, staticRenderFns } from "./ClTabsLegacy.html?vue&type=template&id=0b67bd7b&"
import script from "./ClTabsLegacy.ts?vue&type=script&lang=ts&"
export * from "./ClTabsLegacy.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports